import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

const S = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-heading text-xl font-semibold">{title}</h2>
    <div className="text-sm text-muted-foreground mt-2 space-y-2 leading-relaxed">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 lg:px-12 sticky top-0 bg-background/90 backdrop-blur z-30">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-primary text-primary-foreground grid place-items-center"><Home className="w-4 h-4" /></div>
          <span className="font-heading font-bold text-xl">Rent</span>
        </Link>
        <Link to="/" className="text-sm text-muted-foreground inline-flex items-center gap-1 hover:text-foreground"><ArrowLeft className="w-4 h-4" /> Accueil</Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-heading text-3xl lg:text-4xl font-bold">Politique de confidentialité</h1>
        <p className="text-sm text-muted-foreground mt-2">Conforme au Règlement Général sur la Protection des Données (RGPD - UE 2016/679).</p>

        <S title="1. Responsable du traitement">
          <p>Rent traite les données personnelles nécessaires à la gestion locative de biens meublés (LMNP/LMP) pour le compte des propriétaires, mainteneurs, candidats et locataires utilisateurs de la plateforme.</p>
        </S>
        <S title="2. Données collectées">
          <p>Nous collectons : identité (nom, email, téléphone), rôle, données relatives aux biens, baux, candidatures, tickets de maintenance, écritures comptables, loyers et documents signés. Les données bancaires de paiement sont traitées exclusivement par notre prestataire Stripe et ne transitent jamais en clair par nos serveurs.</p>
        </S>
        <S title="3. Finalités">
          <p>Gestion des biens et des baux, suivi des loyers et de la comptabilité, génération de la liasse fiscale, maintenance, signature électronique des documents locatifs, et facturation de l'abonnement.</p>
        </S>
        <S title="4. Base légale">
          <p>Exécution du contrat de service, respect d'obligations légales (comptables et fiscales) et consentement recueilli à l'inscription.</p>
        </S>
        <S title="5. Durée de conservation">
          <p>Les données sont conservées pendant la durée de la relation contractuelle puis archivées conformément aux obligations légales (notamment 10 ans pour les pièces comptables et fiscales).</p>
        </S>
        <S title="6. Cookies">
          <p>Rent n'utilise que des cookies strictement nécessaires à l'authentification. Aucun cookie publicitaire ni traceur tiers n'est déposé.</p>
        </S>
        <S title="7. Vos droits">
          <p>Vous disposez des droits d'accès, de rectification, d'effacement, de portabilité et d'opposition. Ces droits s'exercent directement depuis l'espace « Mes données » de l'application (export et suppression de compte), ou par demande au responsable de traitement.</p>
        </S>
        <S title="8. Sécurité">
          <p>Mots de passe chiffrés (bcrypt), accès authentifiés par jeton, cloisonnement des données par rôle et par utilisateur.</p>
        </S>
        <p className="text-xs text-muted-foreground mt-10">Document informatif — dernière mise à jour automatique par la plateforme Rent.</p>
      </main>
    </div>
  );
}
